// extracted by mini-css-extract-plugin
export default {"login":"SsoPage_login_loHIT","title":"SsoPage_title_wZj6U"};